import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

import Footer from '../components/footer';

import './page.css';

class Page extends Component {
    get labels() {
        return chainesLocales['Page'][this.props.lang];
    }

    render() {
        return (
            <React.Fragment>
            {
                this.props.viewMode === 'panel' ?
                <div className="d-flex flex-column flex-grow-1 flex-shrink-0">
                    <div className="flex-grow-0 flex-shrink-0" style={{ margin: "auto 0" }}>
                        <div className="Page shadow-lg col-md-8 p-5">
                        {
                            this.props.children
                        }
                        </div>
                        {
                            this.props.showHelpText ? 
                            <p className="help-text my-3 text-white">
                                {this.props.suffixe === "e366f" || this.props.suffixe === "e366e" ? this.labels.helpTextPreLinkNoQuest : this.labels.helpTextPreLink}
                                <a href="#nous-joindre" rel="no-referrer no-follow" onClick={this.onClickNousJoindre.bind(this)} dangerouslySetInnerHTML={{__html: this.labels.contactUslinkText}} />
                                {this.props.suffixe === "e366f" || this.props.suffixe === "e366e" ? this.labels.helpTextPostLinkNoQuest : this.labels.helpTextPostLink}
                            </p> : null
                        }
                    </div>
                    <Footer lang={this.props.lang} />
                </div> :
                <React.Fragment>
                    {this.props.children}
                    {this.props.viewMode === "iframe" ? null : <Footer lang={this.props.lang} logoQcB />}
                </React.Fragment>
            }
            </React.Fragment>
        );
    }

    onClickNousJoindre(e) {
        e.preventDefault();

        this.props.showModal("nous-joindre");
    }
}

Page.defaultProps = {
    lang: "",
    showHelpText: true,
    viewMode: "panel",
    suffixe: ""
};

Page.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired,
    showHelpText: PropTypes.bool,
    viewMode: PropTypes.oneOf(['panel', 'fullscreen', 'iframe']),
    suffixe: PropTypes.string
};

export default Page;